import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_LINK } from "@/lib/api";

export const Footer = () => {
  const { t } = useLang();
  const links = [
    ["/vehicles", t("nav_vehicles")], ["/sourcing", t("nav_sourcing")], ["/sell", t("hero_sell")],
    ["/about", t("nav_about")], ["/contact", t("nav_contact")], ["/legal", t("footer_legal")], ["/privacy", t("footer_privacy")],
  ];
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#070809]">
      <div className="container-x grid gap-12 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-5">
          <p className="display text-2xl">Palissiere Motor Group</p>
          <p className="mt-3 text-sm text-[#8b95a5]">{t("footer_tag")}</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Contact</p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="link-underline block text-sm text-[#e8eaee]">{CONTACT_EMAIL}</a>
          <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="link-underline mt-3 block text-sm text-[#e8eaee]">WhatsApp · {WHATSAPP_DISPLAY}</a>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-5">Navigation</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2.5">
            {links.map(([to, label]) => (
              <li key={to}><Link to={to} className="mono text-[0.65rem] text-[#c7ccd4] transition-colors hover:text-white">{label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="container-x flex flex-col justify-between gap-2 border-t border-white/10 py-6 text-xs text-[#6f7986] md:flex-row">
        <span>© {new Date().getFullYear()} Palissiere Motor Group. {t("footer_rights")}</span>
        <span className="mono text-[0.6rem]">FR · EN</span>
      </div>
    </footer>
  );
};

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label={t("whatsapp_float")}
      className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-[#25d366] text-[#06210f] shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-105 md:bottom-7 md:right-7"
    >
      <MessageCircle size={22} strokeWidth={2.2} />
    </a>
  );
};
